import { jsx as _jsx } from "react/jsx-runtime";
import { Box, LinearProgress, styled } from '@mui/material';
var LoaderWrapper = styled('div')(function (_a) {
    var theme = _a.theme;
    return ({
        position: 'fixed',
        top: 0,
        left: 0,
        zIndex: 2001,
        width: '100%',
        '& > * + *': {
            marginTop: theme.spacing(2),
        },
    });
});
var Loader = function () {
    return (_jsx(Box, { width: "100vw", height: "100vh", bgcolor: "transparent", position: "absolute", zIndex: 999999999999, children: _jsx(LoaderWrapper, { children: _jsx(LinearProgress, { color: "primary" }) }) }));
};
export default Loader;
